export default __webpack_public_path__ + "static/media/error.dcb19f64.gif";